import User from '@/utils/user';
import { format, isSameDay, isSameMonth, isSameYear } from 'date-fns';
import { ru } from 'date-fns/locale';
import { TASK_COLOR, TASK_TONE } from './components/plan-gantt/constants';
import { dateFnsFormat } from '@/helpers/dateFns';
import { getVisibleGanttTasks, normalizeCalendarDate } from '@/packages/ui/components/gantt/helpers';

const user = new User();

export const planNameByRole = () => {
  if (user?.isOperator) return 'Региональный план';
  if (user?.isDepartment) return 'Муниципальный план';
  return 'План моих мероприятий';
};

export const planInstruction = () => {
  const INSTUCTION = {
    id: 338,
    name: 'План мероприятий',
  };
  if (user?.isOrganization) return INSTUCTION;
  return null;
};

export const getAnnounDate = (start, end) => {
  if (start === end) return dateFnsFormat.readableDateWithShortYear(start);
  return `${dateFnsFormat.readableDateWithShortYear(start)}-${dateFnsFormat.readableDateWithShortYear(end)}`;
};

export const formatGanttTaskDate = (startValue, endValue) => {
  const start = normalizeCalendarDate(startValue);
  const end = normalizeCalendarDate(endValue);
  if (!start || !end) return '';
  if (isSameDay(start, end)) return format(start, 'd MMMM yyyy', { locale: ru });
  if (isSameMonth(start, end)) {
    return `${format(start, 'd')}–${format(end, 'd MMMM yyyy', { locale: ru })}`;
  }
  if (isSameYear(start, end)) {
    return `${format(start, 'd MMMM', { locale: ru })} — ${format(end, 'd MMMM yyyy', { locale: ru })}`;
  }
  return `${format(start, 'd MMMM yyyy', { locale: ru })} — ${format(end, 'd MMMM yyyy', { locale: ru })}`;
};

export const prepareAnnounsToGanttItems = (announs) => (announs || []).map((item) => {
  const { id, name, event, event_id, start_at, end_at } = item; // model if ...-sorted
  const published = !!(event || event_id);
  const color = published ? TASK_COLOR.withEvent : TASK_COLOR.withoutEvent;

  return {
    id,
    title: name,
    color,
    tone: published ? TASK_TONE.withEvent : TASK_TONE.withoutEvent,
    published,
    label: formatGanttTaskDate(start_at, end_at),
    tooltip: `${name}: ${formatGanttTaskDate(start_at, end_at)}`,
    startAt: start_at,
    endAt: end_at,
    model: item,
  };
});

export const getAnnouncementsStatistics = (announcements, interval) => {
  const tasks = prepareAnnounsToGanttItems(announcements);
  const visibleTasks = interval
    ? getVisibleGanttTasks(tasks, interval).map(({ task }) => task)
    : tasks;
  const published = visibleTasks.filter((task) => task.published).length;
  return {
    total: visibleTasks.length,
    published,
    plans: visibleTasks.length - published,
  };
};
